export default (value: string) => {
  navigator.clipboard.writeText(value);
};
